<template>
	<v-row v-if="!$store.getters.progress" class="ma-0 pa-3 pb-offset">
		<v-card class="pa-0 background-2 round-card" width="100%">
			<v-card-title class="pa-3">
				<p class="pl-3">Preparazione Spedizione</p>
				<v-spacer></v-spacer>
			</v-card-title>
			<v-divider></v-divider>

			<v-card-text class="pt-5">
				<v-row>
					<v-col cols="12" md="6" lg="4">
						<v-card outlined class="pa-3 outlined-card">
							<div class="subtitle-1 font-weight-bold">Dettagli Documento</div>
							<v-divider class="my-2"></v-divider>
							<div><strong>Numero:</strong> {{ document.number }} / {{ document.sectional ? document.sectional : '' }}</div>
							<div><strong>Data:</strong> {{ document.date | date }}</div>
							<div><strong>Cliente:</strong> {{ document.company ? document.company : '' }}</div>
							<div><strong>Stato:</strong> <v-chip class="ml-3" small :color="document.prepared ? 'success' : 'warning'" text-color="white">{{ document.prepared ? 'Completato' : 'In Corso' }}</v-chip></div>
						</v-card>
					</v-col>

					<v-col cols="12" md="6" lg="8">
						<v-card outlined class="pa-3 outlined-card">
							<div class="subtitle-1 font-weight-bold">Scansione Barcode</div>
							<v-divider class="my-2"></v-divider>
							<v-row align="center">
								<v-col cols="12" sm="7">
									<v-text-field
										v-model="barcode"
										label="Barcode"
										outlined
										dense
										autofocus
										ref="barcodeInput"
										hint="Premi invio per inserire"
										class="pt-5"
										@keyup.enter="scanBarcode"
										:loading="scanning"
										:disabled="scanning"
									></v-text-field>
								</v-col>
								<v-col cols="12" sm="5" class="text-center">
									<v-btn 
										color="primary"
										class="mb-2"
										@click="scanBarcode"
										:loading="scanning"
										:disabled="!barcode || scanning">
										<v-icon left>mdi-barcode-scan</v-icon>
										Scannerizza
									</v-btn>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>

				<v-card outlined class="mt-5 outlined-card">
					<v-card-title class="py-2">
						<div>Riepilogo Prodotti</div>
						<v-spacer></v-spacer>
						<v-text-field
							v-model="search"
							append-icon="search"
							label="Cerca"
							single-line
							hide-details
							dense
							outlined
							class="mt-4 mt-lg-0"
							style="max-width: 300px"
						></v-text-field>
					</v-card-title>
					<v-data-table
						:headers="headers"
						:items="products"
						:search="search"
						:loading="tableLoading"
						sort-by="name"
						class="elevation-0 compact-table clickable-rows"
						:mobile-breakpoint="0"
						@click:row="openEditDialog"
						:items-per-page="15"
						dense>
						<template v-slot:item.status="{ item }">
							<v-chip
								small
								:color="getStatusColor(item)"
								text-color="white">
								{{ item.prepared }} / {{ item.quantity }}
							</v-chip>
						</template>
						
						<template v-slot:footer.page-text="{ pageStart, pageStop }">
							Da {{ pageStart }} a {{ pageStop }} di {{ products.length }}
						</template>						
					</v-data-table>
				</v-card>
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions class="pa-4">
					<v-btn 
						color="error" 
						@click="showResetConfirmation"
						:loading="resettingAll"
						:disabled="!hasPreparations">
						<v-icon left>mdi-delete</v-icon>
						Svuota tutto
					</v-btn>
					<v-spacer></v-spacer>
			</v-card-actions>

			<!-- Alert Dialog -->
			<v-dialog v-model="alertDialog" max-width="400">
				<v-card>
					<v-card-title class="headline">{{ alertTitle }}</v-card-title>
					<v-card-text>{{ alertMessage }}</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" text @click="alertDialog = false">OK</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!-- Edit Dialog -->
			<v-dialog v-model="editDialog" max-width="600">
				<v-card class="background-2 round-card">
					<v-card-title primary-title class="subtitle-1 background-2">Modifica Preparazione</v-card-title>
					<v-divider></v-divider>

					<v-card-text class="pt-4">
						<div class="mb-2">
							<strong>Prodotto:</strong> {{ selectedItem ? selectedItem.name : '' }}
						</div>
						<div class="mb-2">
							<strong>Codice:</strong> {{ selectedItem ? selectedItem.code : '' }}
						</div>
						<div class="mb-2">
							<strong>Barcode:</strong> {{ selectedItem ? selectedItem.barcode : '' }}
						</div>
						<div class="mb-2">
							<strong>Quantità richiesta:</strong> 
							<v-chip
								small
								color="primary"
								text-color="white"
								class="ml-2">
								<strong>{{ selectedItem ? selectedItem.quantity : 0 }}</strong>
							</v-chip>
						</div>
						<v-divider class="my-4"></v-divider>
						<v-text-field
							v-model.number="editedQuantity"
							label="Quantità preparata"
							type="number"
							outlined
							:rules="[quantityRules.required, quantityRules.min, quantityRules.max]"
							:min="0"
							:max="selectedItem ? selectedItem.quantity : 0"
						></v-text-field>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-btn 
							color="error" 
							text 
							@click="resetAllPrepared" 
							:disabled="!selectedItem || selectedItem.prepared <= 0">
							<v-icon left>mdi-delete</v-icon>
							Svuota
						</v-btn>
						<v-spacer></v-spacer>
						<v-btn color="grey" text @click="closeEditDialog">Annulla</v-btn>
						<v-btn 
							color="primary" 
							@click="updateQuantity"
							:disabled="!isValidQuantity">
							Salva
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<!-- Reset Confirmation Dialog -->
			<v-dialog v-model="resetConfirmDialog" max-width="600">
				<v-card class="background-2 round-card">
					<v-card-title primary-title class="subtitle-1 background-2">Conferma eliminazione</v-card-title>
					<v-divider></v-divider>
					<v-card-text class="pt-4">
						Sei sicuro di voler eliminare tutte le quantità preparate per questo documento? Questa azione non può essere annullata.
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="grey" text @click="resetConfirmDialog = false">Annulla</v-btn>
						<v-btn 
							color="error" 
							@click="confirmResetAll"
							:loading="resettingAll">
							Conferma
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-card>
	</v-row>
</template>

<script>

	export default {
		name: 'PrepareShipment',
		props: {
			documentId: {
				type: Number,
				required: true
			},
			modelDef: {
				type: String,
				required: true
			}
		},
	
	data() {
		return {
			document: {},
			products: [],
			loading: true,
			tableLoading: false,
			barcode: '',
			scanning: false,
			search: '',
			lastScannedSuccess: true,
			alertDialog: false,
			alertTitle: '',
			alertMessage: '',
			audioSuccess: null,
			audioError: null,
			headers: [
				// Rimuovo la colonna delle azioni
				{ text: 'Codice', value: 'code', sortable: true },
				{ text: 'Prodotto', value: 'name', sortable: true },
				// { text: 'Barcode', value: 'barcode', sortable: true },
				{ text: 'Stato', value: 'status', sortable: false, align: 'center' }
			],
			editDialog: false,
			selectedItem: null,
			editedQuantity: 0,
			quantityRules: {
				required: value => (value !== null && value !== undefined) || 'Richiesto',
				min: value => value >= 0 || 'La quantità non può essere negativa',
				max: value => {
					if (!this.selectedItem) return true
					return value <= this.selectedItem.quantity || `La quantità non può superare ${this.selectedItem.quantity}`
				}
			},
			resettingAll: false,
			resetConfirmDialog: false,
			productDetailsDialog: false,
			selectedProduct: null
		}
	},
	
	computed: {
		isValidQuantity() {
			return this.editedQuantity !== null && 
				   this.editedQuantity !== undefined && 
				   this.editedQuantity >= 0 && 
				   this.selectedItem && 
				   this.editedQuantity <= this.selectedItem.quantity
		},
		hasPreparations() {
			return this.products.some(product => product.prepared > 0)
		}
	},
	
	created() {
		this.loadDocument()
		this.loadAudio()
	},
	
	methods: {
		// Rimuovo il metodo showProductDetails poiché non serve più
		
		loadAudio() {
			this.audioSuccess = new Audio('/sounds/carico.mp3')
			this.audioError = new Audio('/sounds/errore.mp3')
			
			// Preload audio files
			this.audioSuccess.load()
			this.audioError.load()
		},
		
		loadDocument() {
		
			this.axios.get(`/${this.modelDef}/${this.documentId}/prepare-shipment`).then(response => {
				this.document = response.data.document
				this.products = response.data.products
			
				this.$nextTick(() => {
					if (this.$refs.barcodeInput) {
						this.$refs.barcodeInput.focus()
					}
				})
				this.$store.commit('endProgress')

			}).catch(error => {
				this.showAlert('Errore', 'Impossibile caricare i dati del documento.')
			})
		},
		
		scanBarcode() {
			if (!this.barcode || this.scanning) return
		
			this.scanning = true
		
			this.axios.post(`/${this.modelDef}/${this.documentId}/scan-barcode`, {barcode: this.barcode}).then(response => {
				this.scanning = false
				
				if (response.data.status === 'success') {
					this.audioSuccess.play()
					
					 // Reload all data instead of just updating the specific product
					this.loadDocument()
				}
			
				// Clear barcode field and focus
				this.barcode = ''
				this.$nextTick(() => {
					if (this.$refs.barcodeInput) {
						this.$refs.barcodeInput.focus()
					}
				})
			}).catch(error => {
				this.scanning = false
				this.audioError.play()
				
				if (error.response && error.response.data && error.response.data.message) {
					this.lastScannedProduct = error.response.data.message
				} else {
					this.lastScannedProduct = 'Errore durante la scansione del barcode.'
				}
				this.lastScannedSuccess = false
				
				// Clear barcode field and focus
				this.barcode = ''
				this.$nextTick(() => {
					if (this.$refs.barcodeInput) {
						this.$refs.barcodeInput.focus()
					}
				})
			})
		},
		
		openEditDialog(item) {
			this.selectedItem = JSON.parse(JSON.stringify(item))
			this.editedQuantity = item.prepared
			this.editDialog = true
		},
		
		closeEditDialog() {
			this.editDialog = false
			this.selectedItem = null
			this.editedQuantity = 0
		},
		
		updateQuantity() {
			if (!this.isValidQuantity) return
			
			this.tableLoading = true
			
			this.axios.post(`/${this.modelDef}/${this.documentId}/update-prepared-quantity`, {
				shipment_preparation_id: this.selectedItem.shipment_preparation_id,
				quantity: this.editedQuantity,
				id: this.selectedItem.id // pivot_id
			}).then(response => {
				this.tableLoading = false
				
				if (response.data.status === 'success') {
						// Close the dialog
						this.closeEditDialog()
						
						// Reload all data
						this.loadDocument()
				}
			}).catch(error => {
				this.tableLoading = false
				this.showAlert('Errore', 'Impossibile aggiornare la quantità preparata.')
				console.error(error)
			})
		},
		
		resetAllPrepared() {
			if (!this.selectedItem || this.selectedItem.prepared <= 0) return
			
			this.tableLoading = true
			
			this.axios.post(`/${this.modelDef}/${this.documentId}/update-prepared-quantity`, {
				shipment_preparation_id: this.selectedItem.shipment_preparation_id,
				quantity: 0,
				id: this.selectedItem.id // pivot_id
			}).then(response => {
				this.tableLoading = false
				
				if (response.data.status === 'success') {
						// Close the dialog
						this.closeEditDialog()
						
						// Reload all data
						this.loadDocument()
				}
			}).catch(error => {
				this.tableLoading = false
				this.showAlert('Errore', 'Impossibile azzerare la quantità preparata.')
				console.error(error)
			})
		},
		
		getStatusColor(item) {
			if (item.prepared === 0) return 'grey'
			if (item.prepared < item.quantity) return 'orange'
			return 'success'
		},
		
		showAlert(title, message) {
			this.alertTitle = title
			this.alertMessage = message
			this.alertDialog = true
		},
		
		showResetConfirmation() {
			if (!this.hasPreparations) return
			this.resetConfirmDialog = true
		},
		
		confirmResetAll() {
			this.resetConfirmDialog = false
			this.resetAllPreparation()
		},
		
		resetAllPreparation() {
			if (!this.hasPreparations) return
				
			this.resettingAll = true
				
			this.axios.post(`/${this.modelDef}/${this.documentId}/reset-all-preparation`)
				.then(response => {
					this.resettingAll = false
						
					if (response.data.status === 'success') {
						// Play error sound to indicate deletion
						this.audioError.play()
						
						// Reload all data
						this.loadDocument()
					}
				})
				.catch(error => {
					this.resettingAll = false
					this.showAlert('Errore', 'Impossibile svuotare la preparazione.')
					console.error(error)
				})
		}
	}
}
</script>

<style scoped>
	.v-data-table ::v-deep .v-data-table__wrapper {
		overflow-x: auto;
	}
	
	.compact-table ::v-deep .v-data-table__wrapper table {
		border-spacing: 0;
	}
	
	.compact-table ::v-deep tbody tr td {
		padding-left: 6px !important;
		padding-right: 6px !important;
		padding-top: 8px !important;
		padding-bottom: 8px !important;
		height: auto !important;
	}
	
	.compact-table ::v-deep thead tr th {
		padding-top: 8px !important;
		padding-bottom: 8px !important;
		height: auto !important;
	}
	
	.compact-table ::v-deep .v-data-table__mobile-row {
		min-height: 32px !important;
	}
	
	.compact-table ::v-deep .v-chip--small {
		height: 20px !important;
	}
	
	.clickable-rows ::v-deep tbody tr {
		cursor: pointer !important;
	}
</style>